import React, { useState } from "react";
import { Button, Card, Tabs } from "antd";
import useAPI from "hooks/API";
import useApiKeyStatus from "hooks/useApiKeyStatus";
import TefasHistoryCard from "pages/jobs/TefasHistoryCard";
import CmcHistoryCard from "pages/jobs/CmcHistoryCard";
import PolygonHistoryCard from "pages/jobs/PolygonHistoryCard";
import HistoryGapsCard from "pages/jobs/HistoryGapsCard";
interface Update {
  state: "idle" | "inprogress" | "success" | "failure";
  message?: string;
}

export const SourceParityRateUpdates = () => {
  const [tefasUpdate, setTefasUpdate] = useState<Update>({ state: "idle" });
  const [externalUpdate, setExternalUpdate] = useState<Update>({
    state: "idle",
  });
  const api = useAPI();
  const apiKeys = useApiKeyStatus();

  const handleUpdate = (
    resource: string,
    statusSetter: (u: Update) => void,
  ) => {
    statusSetter({ state: "inprogress" });
    api
      .post(`/admin/resources/update/${resource}`)
      .then((res) => {
        const numRes = parseInt(res);
        if (numRes > 0)
          statusSetter({ state: "success", message: `${res} values updated` });
        else statusSetter({ state: "success", message: `No updates` });
      })
      .catch(() => {
        statusSetter({ state: "failure", message: "Failed to update" });
      });
  };

  const UpdateCard = ({
    title,
    update,
    handler,
  }: {
    title: string;
    update: Update;
    handler: () => void;
  }) => {
    return (
      <Card bordered title={title} style={{ width: "40vw" }}>
        {update.message ? (
          <div style={{ marginBottom: "1em" }}>{update.message}</div>
        ) : null}
        <Button onClick={handler} loading={update.state === "inprogress"}>
          Update
        </Button>
      </Card>
    );
  };

  return (
    <div>
      <h2>Parity Updates</h2>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <UpdateCard
          title={"TEFAS"}
          update={tefasUpdate}
          handler={() => handleUpdate("tefas", setTefasUpdate)}
        />
        <UpdateCard
          title={"BP"}
          update={externalUpdate}
          handler={() => handleUpdate("external", setExternalUpdate)}
        />
      </div>
      {/* One history job per tab; hidden tabs are unmounted, so only the open one polls */}
      <Tabs defaultActiveKey="tefas" destroyInactiveTabPane>
        <Tabs.TabPane tab="TEFAS" key="tefas">
          <TefasHistoryCard />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Crypto (CoinMarketCap)" key="cmc">
          <CmcHistoryCard keyLoaded={apiKeys ? apiKeys.cmc : undefined} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Nasdaq (Polygon)" key="polygon">
          <PolygonHistoryCard keyLoaded={apiKeys ? apiKeys.polygon : undefined} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="History gaps" key="gaps">
          <HistoryGapsCard />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default SourceParityRateUpdates;
